export const lastUpdateDateFormatter = (lastBcpUpdate: string | null) => {
  if (!lastBcpUpdate) return 'NEVER';

  const date = new Date(lastBcpUpdate);
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
  return formattedDate;
};
